const ACCOUNT_FIELD_WEIGHT = 25;
const TECHNOLOGIES_WEIGHT = 50;
const MIN_TECHNOLOGIES = 3;
const PRODUCT_LIST_PER_ITEM = 100 / 3;

export interface ProfileCompletionPercentageData {
  totalPercentage: number;
  accountInfoPercentage: number;
  productListPercentage: number;
}

export interface AmbassadorProfileCompletionData {
  company?: unknown;
  environment?: unknown;
  technologies?: unknown[];
}


export function getProfileCompletionPercentages(
  data: AmbassadorProfileCompletionData | null | undefined
): ProfileCompletionPercentageData {
  const techCount = data?.technologies?.length ?? 0;
  const hasEnoughTechnologies = techCount >= MIN_TECHNOLOGIES;

  const accountInfoPercentage =
    (data?.company ? ACCOUNT_FIELD_WEIGHT : 0) +
    (data?.environment ? ACCOUNT_FIELD_WEIGHT : 0) +
    (hasEnoughTechnologies ? TECHNOLOGIES_WEIGHT : 0);

  const productListPercentage = hasEnoughTechnologies
    ? 100
    : techCount * PRODUCT_LIST_PER_ITEM;

  return {
    totalPercentage: accountInfoPercentage,
    accountInfoPercentage,
    productListPercentage,
  };
}
